import React, {useState, useEffect} from "react";

function Footer() {
  const [is_white_label, setIsWhiteLabel] = useState(localStorage.getItem("is_white_label"));
  console.log('is_white_label: ',is_white_label);
  return (
    <React.Fragment>
      <footer id="footer" className="footer">
        {is_white_label == "0" && (
          <>
            <div className="copyright">
              Copyright <span>&copy; {new Date().getFullYear()}</span> All rights reserved by Hubwallet.
            </div>
            <div className="credits">
              Powered by{" "}
              <a href="javascript:;">
                <img src="./assets/images/hubwallet-logo.svg" alt="Hubwallet" />
              </a>
            </div>
          </>
        )}
      </footer>
      <a
        href="#"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </React.Fragment>
  );
}

export default Footer;
